import React from 'react';
import classNames from 'classnames/bind';
import { Input, Statistic } from '@fuxi/eevee-ui';
import { ACCOUNT_BIND_CODE_NUMBER } from '@commonPackage/constants';
import { VerificationCodeInputProps } from '@commonPackage/components/VerificationCodeInput';
import { useVerificationCodeInput } from '@commonPackage/components/VerificationCodeInput/useVerificationCodeInput';
import styles from './index.module.less';

const cx = classNames.bind(styles);

const { Countdown } = Statistic;

//  用于线索推荐需求，验证码
export const RecommendCodeInput = ({
  countdownTime = 90,
  value,
  phoneNumber,
  validate,
  onChange,
  onBlur,
  msgRequest,
}: VerificationCodeInputProps) => {
  const { handleCaptcha, code, countDownTime, isGettingCode, onCodeChange, toggle } = useVerificationCodeInput({
    countdownTime,
    value,
    validate,
    phoneNumber,
    onChange,
    msgRequest,
  });

  return (
    <div className={cx('recommend-code-input')}>
      <Input
        onBlur={onBlur}
        value={code}
        maxLength={ACCOUNT_BIND_CODE_NUMBER}
        onChange={onCodeChange}
        placeholder="验证码"
      />
      {isGettingCode ? (
        <div className={cx('recommend-code-button-disabled')}>
          <Countdown value={countDownTime} onFinish={toggle} format="s" suffix="s" />
        </div>
      ) : (
        <div className={cx('recommend-code-button')} onClick={handleCaptcha}>
          <div id="captcha"></div>
          获取验证码
        </div>
      )}
    </div>
  );
};
